

















































import Analytics from '../../mixins/analytics';

export default {
	name: 'ProfileItem', 
	props: {
		title: {
			type: String
		},
		text: {
			type: String
		},
		image: {
			type: String
		},
		buttons: {
			type: Array
		}, 
		accordion: {
			type: Array
		}
	},
	methods: {
		handleButtonClick(btn: any): void {
			// Analytics.sendButtonClick(btn.text);
			if (btn.callback){
				btn.callback();
			}
		}
	}
}
